const system_limit = {
    limit_exceeded: '你已達到系統限制，請聯絡支援以獲取協助。',
};
export default Object.freeze(system_limit);
